import { useState } from "react";

const SearchDropdown = ({ userList, setSelecteduser }) => {
  const [searchText, setSearchText] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (value.trim() === '') {
      setFilteredUsers([]);
      setShowDropdown(false);
      return;
    }

    const filtered = userList?.filter(user =>
      // user?.fullName.toLowerCase().includes(value.toLowerCase()) ||
      user?.primaryEmail?.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredUsers(filtered);
    setShowDropdown(true);
  };

  const handleSelectUser = (user) => {
    setSelecteduser(user);
    setSearchText(user.primaryEmail);
    setShowDropdown(false);
  };

  return (
    <div className="w-full md:w-1/2 relative mx-6 mb-0">
      <h3 className="text-lg font-semibold mb-2">Search by Email</h3>
      <input
        type="search"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Search by email or name"
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
      />
      
      {showDropdown && filteredUsers.length > 0 && (
        <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-60 overflow-auto shadow-lg">
          {filteredUsers.map((user, index) => (
            <li
              key={index}
              onClick={() => handleSelectUser(user)}
              className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
              value={user.primaryEmail}
            >
              {user.fullName}
            </li>
          ))}
        </ul>
      )}

      {showDropdown && filteredUsers.length === 0 && (
        <div className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 px-4 py-2 text-gray-500">
          No users found
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;
